import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

const CamerasService = {
    hash: async () => axios.get(API_URL + `/cameras/hash`).then(({data: {data}}) => data).catch(err => { throw err }),

    getProjectAndNext: async (code) => axios.get(API_URL + `/cameras/project-and-next/` + code).then(({data: {data}}) => data).catch(err => { throw err }),
};

export default CamerasService;